module.exports = __webpack_public_path__ + "img/zgzc.a9e75d12.png";